import { shadows as defaultShadows } from 'themes/default/variants/light/shadows';
import { ICssTheme } from 'themes/types';

export const shadows: ICssTheme['shadows'] = defaultShadows;
